import _classCallCheck from "/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
import { AnonymousCredentialPolicy } from "../policies/AnonymousCredentialPolicy";
import { Credential } from "./Credential";
/**
 * AnonymousCredential provides a credentialPolicyCreator member used to create
 * AnonymousCredentialPolicy objects. AnonymousCredentialPolicy is used with
 * HTTP(S) requests that read public resources or for use with Shared Access
 * Signatures (SAS).
 */

export var AnonymousCredential = /*#__PURE__*/function (_Credential) {
  _inherits(AnonymousCredential, _Credential);

  function AnonymousCredential() {
    _classCallCheck(this, AnonymousCredential);

    return _possibleConstructorReturn(this, _getPrototypeOf(AnonymousCredential).apply(this, arguments));
  }

  _createClass(AnonymousCredential, [{
    key: "create",

    /**
     * Creates an {@link AnonymousCredentialPolicy} object.
     *
     * @param nextPolicy -
     * @param options -
     */
    value: function create(nextPolicy, options) {
      return new AnonymousCredentialPolicy(nextPolicy, options);
    }
  }]);

  return AnonymousCredential;
}(Credential);